import { ClientAccountWithAnalyticSummary } from '@lune-climate/lune'
import { TableNew } from '@lune-fe/lune-ui-lib'
import { FC, RefObject } from 'react'

import { ClientAccountsTableRow } from 'views/Settings/ClientAccounts'

const ClientAccountsTable: FC<{
    accounts: ClientAccountWithAnalyticSummary[]
    loading: boolean
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
}> = ({ accounts, loading, pageHistoryRef, currentPage }) => {
    return (
        <TableNew.TableContainer>
            <TableNew
                sx={{ minWidth: accounts.length ? '900px' : 'auto' }}
                stickyHeader
                loading={loading}
                empty={!loading && !accounts.length}
                emptyStateText={{
                    title: 'Nothing to show here',
                    // TODO @FESTINA add `create a new client account`. when create page is ready.
                    description: 'No client accounts match your search',
                }}
                headerCells={
                    <>
                        <TableNew.TableCell colSize={5}>Account</TableNew.TableCell>
                        <TableNew.TableCell colSize={2}>Last active</TableNew.TableCell>
                        <TableNew.TableCell colSize={2} alignEnd>
                            Calculations
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={2} alignEnd>
                            tCO₂e
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd />
                    </>
                }
                bodyCells={
                    <>
                        {accounts.map((account: ClientAccountWithAnalyticSummary, i: number) => (
                            <ClientAccountsTableRow
                                key={`client-account-${i}`}
                                account={account}
                                currentPage={currentPage}
                                pageHistoryRef={pageHistoryRef}
                            />
                        ))}
                    </>
                }
            />
        </TableNew.TableContainer>
    )
}

export default ClientAccountsTable
